import React, { type PropsWithChildren, type ReactElement } from 'react';

import classNames from 'classnames';

import type { ObjectWithId } from '../../types/common';
import RenderRow, { type TableRowProps } from '../../ui/table/table_row';

import styles from '../arrow_opener/arrow_opener.module.css';

type Props<T> = PropsWithChildren<
  TableRowProps<T> & {
    ids: string[];
    id: string;
  }
>;

const CollapsibleTableRow = <T extends ObjectWithId>(
  props: Props<T>,
): ReactElement | null => {
  const isExpanded = props.ids.includes(props.id);
  return (
    <React.Fragment key={props.id}>
      <RenderRow
        {...props}
        className={classNames({ [styles.collapsed]: !isExpanded })}
      />
      {isExpanded ? <tr>{props.children}</tr> : undefined}
    </React.Fragment>
  );
};

export default CollapsibleTableRow;
